export function defaultUserState() {
    return {
        user: null,
    };
}